import {OrderService, AuthService, RegionService} from 'hasta-la-vista-middleware-api/service'
export default {
	data(){
        return {
            loading: true,
            user: {},
            order: {},
        }
    },

	created(){
        this.loading = true;
        Promise.all([AuthService.getUserOrderInfo(), OrderService.getConcessionOrder()]).then(([user,order])=> {
            Promise.resolve(OrderService.makePaymentConcessions(user)).then((order) => {
            	console.log(order);
            })
        })
    },
}


// WEBPACK FOOTER //
// ./src/components/donate/donate/donate.js